import { useEffect } from 'react';
import { getAnalytics, setUserId } from 'firebase/analytics';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { retrieveUserId } from './utils/handleUserId';

import AppRoutes from './routes/';
import NavigationBar from './features/common/_navbar/NavigationBar';
import Toast from './features/toasts';
import { NotificationQR } from './features/common/components/QRNotification';
import { PushNotificationHandler } from './features/pushNotifications';
import { Rating } from './features/rating';

import {
  PushNotificationsPermissionDialog,
  PushNotificationSnackBar,
} from './features/pushNotifications/components';
import {
  closePushNotificationDialogs,
  setPushNotification,
} from './features/pushNotifications/pushNotificationsSlice';
import { usePushNotificationPermission } from './features/pushNotifications/hooks/usePushNotificationPermission';
import { WLoading } from './features/common';

function App() {
  const dispatch = useDispatch();
  const analytics = getAnalytics();
  const { isAuthorized } = useSelector((state) => state.auth);
  const { dialogs, pushNotification } = useSelector(
    (state) => state.pushNotification
  );
  usePushNotificationPermission();

  useEffect(() => {
    const userId = retrieveUserId() || '';
    setUserId(analytics, userId);
  }, [analytics]);

  return (
    <>
      <PushNotificationHandler />
      <WLoading />
      <Router>
        {isAuthorized && (
          <>
            <Toast />
            <NotificationQR />
            <NavigationBar />
            <Rating />

            {pushNotification.show && (
              <PushNotificationSnackBar
                open={pushNotification.show}
                handleClose={() =>
                  dispatch(
                    setPushNotification({ title: '', body: '', show: false })
                  )
                }
              />
            )}

            {dialogs.showPushPermissionModal && (
              <PushNotificationsPermissionDialog
                open={dialogs.showPushPermissionModal}
                onClose={() =>
                  dispatch(
                    closePushNotificationDialogs('showPushPermissionModal')
                  )
                }
              />
            )}
          </>
        )}

        <AppRoutes />
      </Router>
    </>
  );
}

export default App;
